// extracted by mini-css-extract-plugin
module.exports = {"loginpage":"Login_loginpage__UEAV3","loginform":"Login_loginform__3hqaV","advertise":"Login_advertise__3Fs89"};